export default __webpack_public_path__ + "static/likert-a9aab62579379df1d114eaeb122f88a0.svg";